import React, { Component } from 'react';
import { Container } from 'reactstrap';
const version = require('./../../../package.json').version

export default class Footer extends Component {

    render () {
        return (
            <footer className="ar-footer mt-8">
                <Container>
                    <p className="text-center">&copy; {(new Date().getFullYear())} indexAR, v. {version}</p>
                </Container>
            </footer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer/index.js